import { render, staticRenderFns } from "./company-address.vue?vue&type=template&id=6cc5df9a&scoped=true&"
import script from "./company-address.vue?vue&type=script&lang=js&"
export * from "./company-address.vue?vue&type=script&lang=js&"
import style0 from "./company-address.vue?vue&type=style&index=0&id=6cc5df9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc5df9a",
  null
  
)

export default component.exports